'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'user-doctor';
var width = 448;
var height = 512;
var aliases = ["user-md"];
var unicode = 'f0f0';
var svgPathData = 'M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 128a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm72 294.4l0-54.4 96 0 0 41c-21.2 9.3-36 30.4-36 55l0 24c0 11 9 20 20 20s20-9 20-20l0-24c0-11 9-20 20-20s20 9 20 20l0 24c0 11 9 20 20 20s20-9 20-20l0-24c0-24.6-14.8-45.7-36-55l0-36.7c50.7 14 88 60.5 88 115.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-92.8-75.2-168-168-168l-112 0c-92.8 0-168 75.2-168 168 0 13.3 10.7 24 24 24s24-10.7 24-24c0-49.2 29.6-91.5 72-110l0 44.4c-14.3 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.8-9.7-33.3-24-41.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserDoctor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;